import React from 'react';
import { Modal, Grid, Paper } from '@material-ui/core';
import Parameters from '../parameter/Parameters';

function ParameterSelector({
  selectedParameters,
  isSelectorOpen,
  toggleSelector,
  updateSelection,
  areaId,
}) {
  return (
    <Modal open={isSelectorOpen}>
      <Paper>
        <Grid
          container
          style={{ height: '100vh', overflowY: 'scroll', padding: 16 }}
        >
          <Parameters
            onOverlay
            areaId={areaId}
            selectedParameters={selectedParameters}
            toggleSelector={toggleSelector}
            updateSelection={updateSelection}
          />
        </Grid>
      </Paper>
    </Modal>
  );
}

export default ParameterSelector;



// WEBPACK FOOTER //
// ./src/therapeuticArea/ParameterSelector.js